import React from 'react'

import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'

import TrustedBrands from './TrustedBrands'

function TrustedBrandsSection({ locale }) {
  const title = i18n.t('valueProposition.brands.title', {
    ns: 'new-home',
    lng: locale,
  })

  return (
    <section className="trusted-brands-section">
      <div className="trusted-brands-section__container">
        <h2 className="trusted-brands-section__title">
          {title}
        </h2>
        <TrustedBrands />
      </div>
    </section>
  )
}

TrustedBrandsSection.propTypes = {
  locale: string.isRequired,
}

export default TrustedBrandsSection
